export const verify = {
  required: function (text, name) {
    // Vue.$bvModal.show("modal-primary");

    if (text == null || text == "") {
      return "請輸入" + name;
    }

    return null;
  },
  email: function (email) {
    // Vue.$bvModal.show("modal-primary");

    if (email == null || email == "") {
      return "請輸入電子信箱";
    } else {
      var emailRegxp = /[\w-]+@([\w-]+\.)+[\w-]+/; //2009-2-12更正為比較簡單的驗證
      if (emailRegxp.test(email) != true) {
        return "電子信箱格式錯誤";
      }
    }

    return null;
  },
};
